
import Product from '@/components/shop/product.vue';

export default {
  name: 'ProductSliderItem',

  components: {
    Product,
  },

  props: {
    product: {
      type: Object,
      required: true,
    },
  },
};
